import React, { type FC } from "react";
import { withPrefix } from "@tracking/tracking";
import { useTracking, useTranslation } from "@edreamsodigeo/frontend-core";
import { Flex } from "@edreamsodigeo/prisma-design-system";

import { FormLink } from "../FormLink";
import {
  TRACKING_ACTION,
  TRACKING_CATEGORY,
  TRACKING_LABEL,
} from "./config/tracking";
import { type FooterLinkProps } from "./contract";

export const FooterLink: FC<FooterLinkProps> = ({
  onClick,
  screen,
  trackingPrefix,
}) => {
  const { t } = useTranslation();
  const { trackEvent } = useTracking();
  const trackingId = withPrefix(`${screen}_close`, trackingPrefix);

  const handleClick = (): void => {
    trackEvent({
      category: TRACKING_CATEGORY,
      action: TRACKING_ACTION,
      label: TRACKING_LABEL,
    });
    onClick();
  };

  return (
    <Flex justifyContent="center" alignItems="center" margin="small">
      <FormLink
        withTextDecoration
        onClick={handleClick}
        trackingId={trackingId}
      >
        {t("forceLogin.primeLoginPopover.discardPrimeDiscount")}
      </FormLink>
    </Flex>
  );
};
